define('models/extendedMarginManagementReport',["T1", "T1Model"], function (T1, T1Model) {
  T1.Models.ExtendedMarginManagementReport = T1Model.extend({});
  return T1.Models.ExtendedMarginManagementReport;
});
